import { Box, Typography } from "@jewlr/storybook/core"

import Faq from "./faq"
import FreeWarranty from "./free-warranty"
import PeaceOfMind from "./peace-of-mind"
import ProtectionCoverageExample from "./protection-coverage-example"
import ProtectionCoverageJewlr from "./protection-coverage-jewlr"
import WhatsCovered from "./whats-covered"

const ExtendWarranty = () => {
  return (
    <Box>
      <Typography fontSize="26px" mb={4} mt={6} textAlign="center">
        Warranty &amp; Protection
      </Typography>
      <FreeWarranty />
      <ProtectionCoverageJewlr />
      <Box contain maxWidth={{ desktop: "1024px" }}>
        <ProtectionCoverageExample />
        <WhatsCovered />
        <PeaceOfMind />
        <Faq termsConditions />
      </Box>
    </Box>
  )
}

export default ExtendWarranty
